import thunkMiddleware from 'redux-thunk';

export default [thunkMiddleware];
